import type { GetPropertyByIdQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { allPropertiesDetail } from '~/msw/mocks/property'

export function getPropertyByIdHandler() {
  return http.get<
    never,
    never,
    GetPropertyByIdQueryResponse
  >('http://localhost:3000/api/v1/property/:id', async ({ params }) => {
    const { id } = params
    const annonce = allPropertiesDetail.find(annonce => annonce.id === id)
    return HttpResponse.json(annonce)
  })
}
